import { Component } from '@angular/core';
import { breadcrumb, link } from 'src/app/admin/layout/header/header.component';

interface GuideAsset {
  type: 'video' | 'doc';
  title: string;
  description: string;
  url: string;
  thumb?: string;
}

@Component({
  selector: 'app-user-guide-zatca',
  templateUrl: './user-guide-zatca.component.html',
  styleUrls: ['./user-guide-zatca.component.scss']
})
export class UserGuideZatcaComponent {
  header = 'دليل المستخدم لخدمة تسجيل مستورد/مصدر جديد';
  links: link[] = [];
  assets: GuideAsset[] = [
    {
      type: 'video',
      title: "فيديو دليل خدمة هيئة الزكاة والضريبة والدخل",
      description: 'فيديو توضيحي لخدمة تسجيل مستورد/مصدر جديد.',
      url: 'assets/docs/Zatca_user_guide_(compressed).mp4'
    },
    {
      type: 'doc',
      title:"دليل المستخدم لهيئة الزكاة والضريبة والدخل",
      description: 'دليل المستخدم التفصيلي (ملف Word).',
      url: 'assets/docs/Zatca_User_Manual.docx'
    }
  ];

  selected?: GuideAsset;
  showModal = false;

  open(item: GuideAsset) {
    this.selected = item;
    this.showModal = true;
  }

  close() {
    this.showModal = false;
    this.selected = undefined;
  }
}